// hooks/useCategories.ts
import { useQuery } from '@tanstack/react-query';
import { searchApi } from '../api/search';

export const useCategories = () => {
  const {
    data: categories = [],
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['categories'], // Unique key for caching
    queryFn: async () => {
      const data = await searchApi.getSearchCategories();
      return data || [];
    },
    // Uses the global defaults from your QueryClient
  });

  return {
    categories,
    loading: isLoading,
    isError,
    error,
    refetch,
  };
};